import type BpmnModeler from 'camunda-bpmn-js/lib/camunda-platform/Modeler';
import { use } from 'react';
import type { ServiceMap } from '../../types/didi';
import { ModelerContext } from './ModelerContext';

declare class Modeler extends BpmnModeler {
    get<Name extends keyof ServiceMap>(name: Name): ServiceMap[Name];
}

export const useModelerContext = (): Modeler => use(ModelerContext);
